/** @jsx jsx */
import { jsx } from "@emotion/react";
import { useIntl } from "react-intl";

import { PurposedButtonProps } from "./types";
import { useTheme } from "../../../../config/emotion";
import EwaButton2 from "./EwaButton/EwaButton2";
import { labellessButtonCss } from "./styles";

const InlineEditButton = (props: PurposedButtonProps) => {
  const { formatMessage } = useIntl();
  const { colors } = useTheme();

  return (
    <EwaButton2
      buttonColor={colors.secondaryColor}
      iconName="border_color"
      tooltip={formatMessage({ id: "table.row.inline_edit" })}
      css={labellessButtonCss}
      dataCy="inline-edit-button"
      {...props}
    />
  );
};

export default InlineEditButton;
